import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import mlb1 from '../../img/Manual Load Break Switch/mlb1.jpg';
import mlb2 from '../../img/Manual Load Break Switch/mlb2.png'

function LoadBreakSwitch() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="load-break-switch">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">⚡ Manual Load Break Switch</h2>
              <p className="text-muted">
                Safely isolate and switch electrical circuits under load in medium-voltage systems.
              </p>
            </div>

            {/* Intro */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                Manual Load Break Switches are used to manually isolate and switch electrical circuits under load in medium-voltage distribution systems. Ideal for industrial plants, compact substations, outdoor poles, and ring main units (RMUs) where simple, cost-effective switching is required.
              </p>
              <p className="text-muted fw-semibold">Manual Load Break Switch &nbsp; | &nbsp; Medium Voltage Distribution</p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={mlb2}
                  alt="Manual Load Break Switch"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={mlb1}
                  alt="Load Break Switch Setup"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage:</strong> 11kV / 22kV / 33kV</li>
                <li><strong>Current Rating:</strong> 630A to 1250A</li>
                <li><strong>Short-Circuit Withstand:</strong> Up to 25kA for 3 sec</li>
                <li><strong>Operation:</strong> Manual (rotary handle or gang-operated)</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 62271-103</strong> – High-voltage switches</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>Manual load switching under normal conditions</li>
                <li>Quick-make, quick-break mechanism for safety</li>
                <li>Compact and rugged design for indoor or outdoor use</li>
                <li>Visible isolation ensures safe maintenance</li>
                <li>Interlocking system to prevent misoperation</li>
                <li>Optional integrated earthing switch</li>
              </ul>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default LoadBreakSwitch;
